export enum MessageTemplateEvent {
    Approved = 'approved',
    Cancelled = 'cancelled',
    Checkin = 'checkin',
    Completed = 'completed',
}
